import { t as a, f as A } from "../../chunks/format.CWVCbH1D.js";
function D(t) {
  return Math.trunc(+a(t) / 1e3);
}
const u = "MMMM d", T = "MMMM d, y", d = "MMMM dd, y", I = "MM/dd/yyyy", O = "MM/dd/yyyy HH:mm a", y = "E, MM/dd/yyyy", R = "EEEE, MMM d", m = "h:mm", i = "h:mmaaa", _ = (t) => D(new Date(t)) > 0, Y = (t, e) => !t || !_(t) ? null : new Date(new Date(t).getTime() - e * 60 * 1e3), H = (t, e, r) => {
  if (!t || !_(t))
    return null;
  const n = new Date(t);
  let o = n.getHours(), M = n.getMinutes();
  const c = o >= 12 ? r : e;
  return o %= 12, o = o === 0 ? 12 : o, M = M < 10 ? `0${M}` : M, `${o}:${M}${c}`;
}, $ = (t, e, r) => {
  if (!t || t.length < 4)
    return null;
  let n = 0;
  parseInt(t.slice(0, 2), 10) < 10 ? (n = parseInt(t.slice(1), 10), n === 0 && (n = 12)) : parseInt(t.slice(0, 2), 10) > 12 ? n = parseInt(t.slice(0, 2), 10) - 12 : n = parseInt(t.slice(0, 2), 10);
  const o = t.slice(-2), M = parseInt(t.slice(0, 2), 10) >= 12 ? r : e;
  return `${n}:${o}${M}`;
};
function s(t, e, r) {
  return !t || !_(t) ? null : A(new Date(t), e, r);
}
const E = (t) => s(t, i) || "", l = (t) => s(t, m) || "", N = (t, e) => {
  const r = s(t, T), n = s(e, T);
  return r === n ? `${r}` : `${s(t, u)} - ${n}`;
}, p = (t, e) => {
  const r = E(e);
  return r ? `${l(t)} - ${r}` : E(t);
};
export {
  u as DATE_MONTH_DAY_FORMAT,
  T as DATE_MONTH_DAY_YEAR_FORMAT,
  O as DATE_MONTH_DAY_YEAR_HOUR_MINUTES_AMPM,
  I as DATE_MONTH_DAY_YEAR_TWO_DIGIT,
  y as DATE_MONTH_DAY_YEAR_WEEK_TWO_DIGIT,
  d as DATE_MONTH_ZERO_DAY_YEAR_FORMAT,
  i as DATE_TIME_MINUTES_AM_FORMAT,
  m as DATE_TIME_MINUTES_FORMAT,
  R as DATE_WEEK_DAY_MONTH_THREE_DIGITS_DAY,
  N as formatEventStartAndEndDates,
  p as formatEventStartAndEndTime,
  l as formatEventTime,
  E as formatEventTimeWithAMFormat,
  $ as formatTime,
  s as getFormattedDate,
  H as getFormattedTime,
  Y as getZonedDate,
  _ as isValidDate
};
